import { render, staticRenderFns } from "./add-scope-of-application.vue?vue&type=template&id=41dd46f7&scoped=true&"
import script from "./add-scope-of-application.vue?vue&type=script&lang=js&"
export * from "./add-scope-of-application.vue?vue&type=script&lang=js&"
import style0 from "./add-scope-of-application.vue?vue&type=style&index=0&id=41dd46f7&lang=scss&scoped=true&"
import style1 from "./add-scope-of-application.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dd46f7",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41dd46f7')) {
      api.createRecord('41dd46f7', component.options)
    } else {
      api.reload('41dd46f7', component.options)
    }
    module.hot.accept("./add-scope-of-application.vue?vue&type=template&id=41dd46f7&scoped=true&", function () {
      api.rerender('41dd46f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/manager/add-scope-of-application.vue"
export default component.exports